import axios from 'axios';
import { useEffect, useState } from 'react';
import Box from 'elements/Box';
import { Button, Chip, IconButton, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {ProjectConfig} from 'Global';
import AlertDialog from 'elements/AlertDialog';
import AddIcon from '@mui/icons-material/Add';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { useSnackbar } from 'notistack';

import 'assets/css/main.css';

import CatalogsEditor from './CatalogsEditor';
import { ApiRequest } from 'GlobalFunctions';

export default function CatalogsList(props: any) {
  const { setLoading } = props;
  const { enqueueSnackbar } = useSnackbar();

  const [list, setList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [openEditor, setOpenEditor] = useState(false);
  const [activeItem, setActiveItem] = useState(0);
  const [openAlert, setOpenAlert] = useState(false);

  useEffect(() => {
    loadList();
  }, [page]);

  const loadList = async () => {
    setLoading(true);

    await ApiRequest({
      url: "/catalogs/list",
      method: "get",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      query: {
        page: page,
      },
      setResponse: (response: any) => {
        setList(response.list);
        setTotalPages(response.total_pages);
        setLoading(false);
      },
    });
  };

  const handleDelete = (catalog_id: number) => {
    setActiveItem(catalog_id);
    setOpenAlert(true);
  };

  const deleteItem = () => {
    const body = {
      catalog_id: activeItem
    };

    axios.post(ProjectConfig.api_url + "/catalogs/deleteItem", body)
      .then((response) => {
        if (response.data.status === "success") {
          enqueueSnackbar('Catalogo eliminado con éxito', { variant: 'success' });
          loadList();
        }
      })
      .catch((err) => {
        console.log(err.data);
      })
      .finally(() => {
        setOpenAlert(false);
      });
  };

  return (
    <div id='CatalogsList' className='ModuleContainer'>
      <div className='ModuleWrapper'>
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h2 className="h2_title">Catalogos</h2>
            <span className="h2_subtitle">Lista</span>
          </div>
          <div className="boxContainerActions">
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => {
                setActiveItem(0);
                setOpenEditor(true);
              }}
            >
              Agregar
            </Button>
          </div>
        </div>

        <Box id="CatalogsListIn" className="box100">
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Portafolio</TableCell>
                  <TableCell>Productos</TableCell>
                  <TableCell align="right">Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item: any, i) => (
                  <TableRow key={i} hover role="checkbox">
                    <TableCell>{item.catalog_id}</TableCell>
                    <TableCell>{item.catalog_name}</TableCell>
                    <TableCell>
                      {(() => {
                        const products = typeof item.products === 'string'
                          ? JSON.parse(item.products)
                          : item.products || [];
                        const count = products.length;
                        return (
                          <Chip
                            label={`${count} producto${count !== 1 ? 's' : ''}`}
                            color="primary"
                            variant="outlined"
                            size="small"
                          />
                        );
                      })()}
                    </TableCell>
                    <TableCell align="right">
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        style={{ marginRight: "10px" }}
                        startIcon={<ModeEditIcon />}
                        onClick={() => {
                          setActiveItem(item.catalog_id);
                          setOpenEditor(true);
                        }}
                      >
                        Editar
                      </Button>

                      {(localStorage.getItem('role_id') === "1" || localStorage.getItem('role_id') === "2") &&
                      <IconButton aria-label="delete" color="primary" onClick={() => handleDelete(item.catalog_id)}>
                        <DeleteOutlineOutlinedIcon />
                      </IconButton>
                      }
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(event, value) => setPage(value)}
            color="primary"
            style={{ marginTop: "20px", alignSelf: "center" }}
          />
        </Box>
      </div>

      <AlertDialog
        open={openAlert}
        setOpen={setOpenAlert}
        subtitle="¿Está seguro que desea eliminar este catalogo?"
        send={deleteItem}
      />

      <CatalogsEditor
        setLoading={setLoading}
        openEditor={openEditor}
        setOpenEditor={setOpenEditor}
        catalog_id={activeItem}
        loadList={loadList}
      />
    </div>
  );
}
